import React from "react";
import PropTypes from "prop-types";

export default function CardHeader({ icon, text, className = "" }) {
  return (
    <div className={`card-header ${className}`.trim()}>
      <i className="material-icons align-icon">{icon}</i>
      &nbsp;
      {text}
    </div>
  );
}

CardHeader.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
  className: PropTypes.string,
};
